export default __webpack_public_path__ + "static/media/megaYacht.daae3d51.webp";